/** Airport gallery — mirrors website/gallery.php */

export const GALLERY_PHOTOS = [
  {
    src: '/images/airport/airport-terminal-lobby.jpg',
    caption: 'Terminal lobby',
  },
  {
    src: '/images/airport/airport-exterior-view.jpg',
    caption: 'Terminal exterior',
  },
  {
    src: '/images/airport/airport-night-exterior.jpg',
    caption: 'Airport at night',
  },
  {
    src: '/images/airport/departure-check-in-area.jpg',
    caption: 'Departure check-in',
  },
  {
    src: '/images/airport/airport-check-in-counters.jpg',
    caption: 'Check-in counters',
  },
  {
    src: '/images/airport/airport-shopping-area.jpg',
    caption: 'Shopping area',
  },
  {
    src: '/images/airport/airport-premium-lounge-dining.jpg',
    caption: 'Lounge dining',
  },
  {
    src: '/images/airport/airport-vip-lounge-seating.jpg',
    caption: 'VIP lounge',
  },
  {
    src: '/images/airport/airport-business-lounge.jpg',
    caption: 'Business lounge',
  },
  {
    src: '/assets/airport/prayer-room.jpg',
    caption: 'Prayer room',
  },
];
